import * as actionTypes from '../actions/actionTypes'
import {updateObject} from "../../utility";

const initialState = {
    error: null,
    loading: false,
    xogroups: [],
    activities: {},
    selectedId: null,
    callBackNeeded: false
};

const fetchXogroupsStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchXogroupsSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, xogroups: action.xogroups, selectedId: action.selectedId, callBackNeeded: action.callBackNeeded})
};

const fetchXogroupsFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const editXogroupsStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const editXogroupsSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, xogroups: action.xogroups})
};

const editXogroupsFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const fetchGroupActivitiesStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchGroupActivitiesSuccess = (state, action) => {
    return updateObject(state, {loading: false, error: null, activities: action.activities, callBackNeeded: action.callBackNeeded})
};

const fetchGroupActivitiesFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error, callBackNeeded: action.callBackNeeded})
};

const fetchGroupInstancesStart = (state, action) => {
    return updateObject(state, {loading: true})
};

const fetchGroupInstancesSuccess = (state, action) => {
    let groups = [...state.xogroups]
    let name = action.groupName
    let groups2 = groups.map((g, i) => {
        if (g.name === name) {
            g.instances = action.instances
        }
        return g
    });

    return updateObject(state, {loading: false, error: null, xogroups: groups2})
};

const fetchGroupInstancesFail = (state, action) => {
    return updateObject(state, {loading: false, error: action.error})
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case actionTypes.XOGROUPS_FETCH_START: return fetchXogroupsStart(state, action);
        case actionTypes.XOGROUPS_FETCH_SUCCESS: return fetchXogroupsSuccess(state, action);
        case actionTypes.XOGROUPS_FETCH_FAIL: return fetchXogroupsFail(state, action);
        case actionTypes.EDIT_XOGROUPS_START: return editXogroupsStart(state, action);
        case actionTypes.EDIT_XOGROUPS_SUCCESS: return editXogroupsSuccess(state, action);
        case actionTypes.EDIT_XOGROUPS_FAIL: return editXogroupsFail(state, action);
        case actionTypes.FETCH_GROUP_ACTIVITIES_START: return fetchGroupActivitiesStart(state, action);
        case actionTypes.FETCH_GROUP_ACTIVITIES_SUCCESS: return fetchGroupActivitiesSuccess(state, action);
        case actionTypes.FETCH_GROUP_ACTIVITIES_FAIL: return fetchGroupActivitiesFail(state, action);
        case actionTypes.FETCH_GROUP_INSTANCES_START: return fetchGroupInstancesStart(state, action);
        case actionTypes.FETCH_GROUP_INSTANCES_SUCCESS: return fetchGroupInstancesSuccess(state, action);
        case actionTypes.FETCH_GROUP_INSTANCES_FAIL: return fetchGroupInstancesFail(state, action);
        default: return state;
    }
};

export default reducer;